// extracted by mini-css-extract-plugin
module.exports = {"container":"orders-list-container-module__container___3eUgz","noOrders":"orders-list-container-module__noOrders___3lq2T"};